module.exports = __webpack_public_path__ + "static/media/visa.23126940.svg";